import React from 'react';
import { useTranslation } from 'react-i18next';
import { Item } from '@/types/item';
import Grid, { itemText } from '@/components/molecules/section/Grid';
import Container from '@/components/molecules/section/Container';
import { transformDateString } from '@/utilities/datetime';

const View: React.FC<{ item: Item }> = ({ item }) => {
  const { t } = useTranslation();

  const items = [
    itemText(
      t('item.purchase.sold'),
      item.soldDate && item.soldDate !== '0000-00-00 00:00:00' ? `✅ ${t('item.purchase.sold')}` : '',
    ),
    itemText(t('item.purchase.sold_on'), transformDateString(item.soldDate, 'DD/MM/YYYY HH:mm:ss')),
    itemText(t('item.purchase.payment_method'), item.buyerPaymentMethod),
    itemText(t('item.purchase.delivery_date'), transformDateString(item.estimatedDeliveryDate, 'DD/MM/YYYY')),
  ];

  return (
    <Container
      title={t('item.purchase.title')}
      actions={[]}
      testId="purchase_info"
    >
      <Grid
        column={5}
        items={items}
      />
    </Container>
  );
};

export default View;
